import * as Highcharts from 'highcharts';

import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { HighchartsChartModule } from 'highcharts-angular';

// Import Highcharts modules - in v12, just importing them is enough
import { ChartData, ChartType } from '@unified-ui/shared-components';
// import 'highcharts/modules/export-data';
import 'highcharts/modules/exporting';
import 'highcharts/modules/full-screen';
import { SelectModule } from 'primeng/select';
import { ChartOptions } from './chart-type-options';

@Component({
    selector: 'dashboard-chart',
    standalone: true,
    imports: [SelectModule, HighchartsChartModule],
    templateUrl: './dashboard-chart.component.html',
    styleUrl: './dashboard-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardChartComponent {
    /** Emits to set the chart instance in the parent */
    public readonly chartReady = output<Highcharts.Chart>();
    /** Input for chart type */
    public chartType = input<ChartType>();
    /** Input for chart data - xAxis, yAxis and series */
    public chartData = input<ChartData>();
    /** Highcharts instance */
    protected Highcharts: typeof Highcharts = Highcharts;
    /** Default chart options */
    protected chartOptions = ChartOptions;
    /** Full configuration for the current chart */
    protected internalChartOptions = computed(() => {
        const opt = { ...this.chartOptions.base, ...this.chartOptions[this.chartType() || 'column'], ...this.chartData() };
        return opt;
    });
    protected updateFlag = false;

    public onChartInstance(chart: Highcharts.Chart) {
        // Send chart to parent
        this.chartReady.emit(chart);
    }
}
